import { render, staticRenderFns } from "./ManageKraList.vue?vue&type=template&id=1c4b1766&scoped=true"
import script from "./ManageKraList.vue?vue&type=script&lang=js"
export * from "./ManageKraList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4b1766",
  null
  
)

export default component.exports